import { render, staticRenderFns } from "./NavbarSplitter.vue?vue&type=template&id=7c4d645b&"
var script = {}
import style0 from "./NavbarSplitter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports